/* Header que se esconde al bajar y vuelve al subir (sections/header.liquid, ajuste
   "Enable sticky header"). El header sigue siendo sticky; escondido usa `top: -alto`, así que
   arriba de la página se va con el scroll como cualquier contenido y, ya fuera de vista, la
   transición de `top` lo hace entrar o salir. No usa transform: crearía un bloque contenedor y
   rompería los paneles `position: fixed` que viven dentro del header (ubicación, cuenta).
   En <html> deja --cv-header-offset (alto si está visible y pegado, 0 si no) para lo que se
   pega debajo del header. */
(function () {
  'use strict';

  var HIDE_AFTER = 6;    // px bajando seguidos para esconderlo
  var SHOW_AFTER = 10;   // px subiendo seguidos para mostrarlo

  // Decide el siguiente estado. state = { y, run, hidden }; run acumula px en la misma dirección
  // (positivo bajando, negativo subiendo). maxY es el scroll máximo de la página.
  function step(state, y, maxY, height, locked) {
    var next = { y: y, run: state.run, hidden: state.hidden };
    if (y <= 0) {
      next.run = 0;
      next.hidden = false;
      return next;
    }
    // Rebote de iOS al final de la página: no cuenta como subir.
    if (maxY > 0 && y > maxY) {
      next.y = state.y;
      return next;
    }
    var dy = y - state.y;
    if (!dy) return next;
    next.run = (dy > 0) === (state.run > 0) ? state.run + dy : dy;
    if (locked) {
      next.hidden = false;
    } else if (next.run >= HIDE_AFTER && y > height) {
      next.hidden = true;
    } else if (next.run <= -SHOW_AFTER) {
      next.hidden = false;
    }
    return next;
  }

  window.CvHeaderAutohide = { step: step };

  var script = document.currentScript;
  var section = script && document.getElementById(script.getAttribute('data-cv-header'));
  if (!section || !window.addEventListener) return;

  var root = document.documentElement;
  var state = { y: window.pageYOffset || 0, run: 0, hidden: false };
  var height = 0;
  var ticking = false;
  var shown = '';

  function measure() {
    height = section.offsetHeight;
    section.style.setProperty('--cv-header-h', height + 'px');
  }

  // Mientras haya algo abierto del header (mega menú, buscador, menús, paneles), no se esconde.
  function locked() {
    var active = document.activeElement;
    if (active && active !== document.body && section.contains(active) &&
        /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return true;
    if (document.querySelector('.header-location-panel--open, .account-bottom-sheet--open, .cv-sh:not([hidden])')) return true;
    // Dentro del menú del celular quedan pestañas abiertas aunque el menú esté cerrado; el
    // menú mismo cuenta por su botón [data-action="toggle-menu"].
    var open = section.querySelectorAll('[aria-expanded="true"], .cmm-nav-item.is-active, .is-open');
    for (var i = 0; i < open.length; i++) {
      if (!open[i].closest || !open[i].closest('#mobile-menu')) return true;
    }
    return false;
  }

  function render() {
    var offset = (!state.hidden && state.y > 0 ? height : 0) + 'px';
    if (shown === state.hidden + offset) return;
    shown = state.hidden + offset;
    section.classList.toggle('cv-hdr--hidden', state.hidden);
    root.style.setProperty('--cv-header-offset', offset);
  }

  function update() {
    ticking = false;
    var maxY = Math.max(0, (document.documentElement.scrollHeight || 0) - window.innerHeight);
    state = step(state, window.pageYOffset || 0, maxY, height, !state.hidden && locked());
    render();
  }

  measure();
  if (state.y > height) state.hidden = true;
  root.classList.add('cv-hdr-autohide');
  render();
  void section.offsetTop; // aplica el estado inicial antes de encender la animación
  // La animación se enciende después de pintar el estado inicial, para no verla al cargar.
  (window.requestAnimationFrame || setTimeout)(function () { root.classList.add('cv-hdr-anim'); });

  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      (window.requestAnimationFrame || setTimeout)(update);
    }
  }, { passive: true });

  window.addEventListener('resize', function () { measure(); render(); });
  if (window.ResizeObserver) new ResizeObserver(function () { measure(); render(); }).observe(section);
})();
